import React from 'react';
import { Box, Typography } from '@mui/material';
import styles from '../styles.module.scss';
import { TableRowProps } from '../types';

export const TableRow = ({
  leftTitle,
  leftValue,
  rightTitle,
  rightValue,
  className
}: TableRowProps) => {
  return (
    <Box className={`${styles.tableRow} ${className}`}>
      <Box className={styles.tableColumn}>
        <Box className={styles.leftCell}>
          <Typography variant="h6" className={styles.cellTitle}>
            {leftTitle}
          </Typography>
        </Box>
        <Box className={styles.rightCell}>
          <Typography variant="h6" className={styles.cellValue}>
            {React.createElement(leftValue)}
          </Typography>
        </Box>
      </Box>
      <Box className={styles.tableColumn}>
        <Box className={styles.leftCell}>
          <Typography variant="h6" className={styles.cellTitle}>
            {rightTitle}
          </Typography>
        </Box>
        <Box className={styles.rightCell}>
          <Typography variant="h6" className={styles.cellValue}>
            {React.createElement(rightValue)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
